var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{staticClass:"activity-sparkline custom-apex-style",attrs:{"type":"bar","height":_vm.height,"options":_vm.chartOptions,"series":_vm.chartSeries}})
}
var staticRenderFns = []

export { render, staticRenderFns }